<template>
  <div  class="messageCentertuwenPage">
      <mu-appbar class="XR-head" :title="titleTextValue">
        <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>
    </mu-appbar>

     <div class="bannerlist" >
        <section :style="{marginTop: mTop +'px'}" class="wh_content" @touchmove="fn">
            <div :class="className" class="wh_swiper" @touchstart="s" @touchmove="m" @touchend="e">
                <div class="wh_slide" @click="clickSlide" :style="{height:fullHeitht +'px'}" v-for="(img,index) in info.ImgDetailList" :key="img.Id">
                   <img ref="heiht" :src="img.ImgPath" />
                   <div class="title" v-if="titleShow">
                        <p>
                            <span style="padding-right: 10px;"> <span style="font-size: 20px;">{{index+1}}</span> /{{info.ImgDetailList.length}}</span>
                            {{img.Remark}}
                        </p>
                   </div>
                </div>
            </div>
        </section>
      </div>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>
<script>
    export default {      
        name :'XR-swiper',
        data() {
            return {
                fullHeitht:document.documentElement.clientHeight-56,
                slidesLength: 1,
                _width: 0,
                auto: true,
                slideing: true,
                timer1: '',
                className: '',
                dom: {},
                t: {
                    sx: 0,
                    s: 0,
                    m: 0,
                    e: 0
                },
                index: 1,
                mTop:0,
                banHeigth:0,
                titleTextValue:'',
                info:{},
                titleShow:true
            }
        },
        props: {
            //滑动所需要的时间
            autoPlay: {
                default: true
            },
            //一次滑动需要走多久
            duration: {
                default: 500
            },
            //两次滑动间隔的时间
            interval: {
                default: 2500
            },
        },
        mounted() {
            this.getInformationDetail()
        },
        methods: {            
            GoHistory(){
                this.$router.goBack()
            },    
             clickSlide() {
                this.titleClick()
                this.$emit('click')
            },
            s(x) {
                if (this.slideing) {
                    this.clearTimeOut()
                    this.t.sx = this.getTransform()
                    this.t.s = x.touches[x.touches.length - 1].clientX
                }
            },
            m(x) {
                if (this.slideing && this.t.s != -1) {
                    this.clearTimeOut()
                    this.dom = this.dom
                    this.t.m = x.touches[x.touches.length - 1].clientX - this.t.s
                    this.setTransform(this.t.m + this.t.sx)
                }
            },
            e(x) {
                if (this.slideing && this.t.s != -1) {
                    this.clearTimeOut()
                    this.setTransform(this.t.m + this.t.sx)
                    var x = this.getTransform()
                    x += this.t.m > 0 ? this._width * 0.3 : this._width * -0.3
                    this.index = Math.round(x / this._width) * -1
                    this.wh('touch')
                }
            },
            setTransform(num) {
                this.dom.transform = `translate3d(${num}px, 0px, 0px)`
                this.dom['-webkit-transform'] = `translate3d(${num}px, 0px, 0px)`
                this.dom['-ms-transform'] = `translate3d(${num}px, 0px, 0px)`
            },
            getTransform() {
                var x = this.dom.transform || this.dom['-webkit-transform'] || this.dom['-ms-transform'];
                x = x.substring(12)
                x = x.match(/(\S*)px/)[1]
                return Number(x)
            },
            fn(e) {
                e.preventDefault()
            },
            prevSlide() {
                this.clearTimeOut()
                this.index--
                this.wh()
            },
            nextSlide() {
                this.clearTimeOut()
                this.index++
                this.wh()
            },
            slideTo(index) {
                this.clearTimeOut()
                this.index = index + 1
                this.wh()
            },
            wh(type) {
                this.slideing = false
                this.dom.transition = type == 'touch' ? '250ms' : this.duration + 'ms'
                this.setTransform(this.index * -1 * this._width)
                this.t.m = 0
                this.t.s = -1 //保证下次重新赋值
                if (this.autoPlay) {
                    this.setTime()
                }
                var timeDuration = type == 'touch' ? '250' : this.duration
                setTimeout(() => {
                    this.dom.transition = '0s'
                    if (this.index >= this.slidesLength + 1) {
                        this.index = 1
                        this.setTransform(this.index * -1 * this._width)
                    }
                    if (this.index <= 0) {
                        this.index = this.slidesLength
                        this.setTransform(this.index * -1 * this._width)
                    }
                    this.$emit('transtionend', this.index - 1)
                    this.auto = true
                    this.slideing = true
                }, timeDuration)
            },
            setTime() {
                this.timer1 = window.setTimeout(() => {
                    window.clearTimeout(this.timer1)                    
                }, this.interval)
            },
            starDom() {
                var SlideDom = document.querySelector('.' + this.className).getElementsByClassName('wh_slide')
                this.slidesLength = SlideDom.length
                var cloneDom1 = SlideDom[0].cloneNode(true) //向最后append
                var cloneDom2 = SlideDom[this.slidesLength - 1].cloneNode(true) //向最前append
                document.querySelector('.' + this.className).insertBefore(cloneDom2, SlideDom[0])
                document.querySelector('.' + this.className).appendChild(cloneDom1)
                this._width = document.querySelector('.' + this.className).offsetWidth
                this.dom = document.querySelector('.' + this.className).style
            },
            clearTimeOut() {
                this.auto = false
                window.clearTimeout(this.timer1)
            },            
            getInformationDetail(){
                var ths = this;   
                ths.$post(
                    "/Shop/articleServer/GetInformationDetailImg",{id: this.$route.query.id}
                ).then(function(res) {
                    if(!res.IsSuccess){
                    }else{          
                        ths.info = res.Data;
                        ths.UpdateTitle(res.Data.Title)
                        ths.loaded = false
                        ths.$refs.XRtoast.hide()

                        ths.className = `wh_swiper_${Math.random().toFixed(3) * 1000}`
                        setTimeout(() => {
                            //克隆dom
                            ths.starDom()
                            ths.dom.transform = `translate3d(${ths._width * -1}px, 0px, 0px)`
                            ths.dom['-webkit-transform'] = `translate3d(${ths._width * -1}px, 0px, 0px)`
                            ths.dom['-ms-transform'] = `translate3d(${ths._width * -1}px, 0px, 0px)`
                            if (ths.autoPlay) {
                                ths.setTime()
                            }
                        }, 50)
                        
                    }
                });
            },   
            titleClick(){
                this.titleShow = !this.titleShow
            },         
            UpdateTitle(val){
                this.titleTextValue = val
            }
        }
    }
</script>
<style>
body .messageCentertuwenPage{
  background: black;
}
.messageCentertuwenPage .XR-head .mu-appbar{
  height: 46px;
  text-align: center;
}
.messageCentertuwenPage .XR-head .mu-appbar.fixed{  
  padding:0;
  position: fixed;
  top:0;
  left: 0;
}
.messageCentertuwenPage .XR-head .mu-appbar-title {
  font-size: 16px;
  padding-right: 48px;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.messageCentertuwenPage .XR-head .title .mu-icon-button {
  position: absolute;
  left: 0;
  top: 0;
  color:white;
}
.messageCentertuwenPage .XR-head .title .title-text {
  margin: 0;
  line-height: 48px;
}
.messageCentertuwenPage .wh_content {
    position: relative;
    z-index: 1;
    overflow: hidden;
    width: 100%;
}
.messageCentertuwenPage .wh_content  .wh_swiper {
    width: 100%;
    display: -webkit-box;
    display: -moz-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    -moz-transition-duration: 0s linear;
    -webkit-transition-duration: 0s linear;
    -o-transition-duration: 0s linear;
    transition-duration: 0s linear;
}
.messageCentertuwenPage  .wh_indicator {
    position: absolute;
    bottom: 10px;
    width: 100%;
    text-align: center;
    background: 0 0;
}
.messageCentertuwenPage  .wh_indicator_item {
    display: inline-block;
    width: 6px;
    height: 6px;
    margin: 1px 2px;
    cursor: pointer;
    border-radius: 100%;
    background: #666;
    border:1px solid #666;
}
.messageCentertuwenPage  .wh_show_bgcolor {
    background: white;
}
.messageCentertuwenPage .wh_content{
    width: 100%;
}
.messageCentertuwenPage .wh_content .wh_slide{
    width: 100%;
    height: 100%;
    display: flex;
    align-items:center;
}
.messageCentertuwenPage .wh_content .wh_slide .title{
    width: 100%;
    color: #fff;
    line-height: 25px;
    padding: 0 16px; 
    position: absolute;
    bottom: 20px;
    background: black;
}
.messageCentertuwenPage .wh_content .wh_slide .title p{
  width:100%;
  word-break:break-all;
  display:-webkit-box;
  -webkit-line-clamp:5;
  -webkit-box-orient:vertical;
  overflow:hidden;
}
.messageCentertuwenPage .wh_content .wh_slide img{
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/pages/informationImgDetail.vue